'use client'
import React from 'react'
import styles from './styles.module.scss'

const ViewMoreButton: React.FC<{
  children: React.ReactNode
  onClick: () => void
}> = ({ children, onClick }) => {
  return (
    <button className={styles.button} onClick={onClick}>
      {children}
    </button>
  )
}

export default ViewMoreButton
